'use client';

import React from 'react';
import { connect } from 'react-redux';
import { GenericInputField } from '../../profileInfo/components/Forms/GenericInputField/GenericInputField';
import { DisplayField } from '../../profileInfo/components/Forms/GenericInputField/DisplayField';
import { RadioButtonField } from '../../profileInfo/components/Forms/GenericInputField/RadioButtonField';
import { PhoneInputField } from '../../profileInfo/components/Forms/GenericInputField/PhoneInputField';
import GenderSelection from './GenderSelection';

const FormFields = ({ errors = {}, touched = {}, mobileInfo, userGroup }) => {
  return (
    <>
      {/* <DisplayField label='موبایل' value={mobileInfo} name='mobile' twoItemInOneRow={true} /> */}
      <GenericInputField label={'نام'} name='firstName' type='text' placeholder={'نام خود را وارد کنید'} errors={errors} touched={touched} />
      <GenericInputField label={'نام خانوادگی'} name='lastName' type='text' placeholder={'نام خانوادگی خود را وارد کنید'} errors={errors} touched={touched} />
      <GenderSelection name='gender' label='جنسیت' errors={errors} touched={touched} />
      {/* <PhoneInputField label={'شماره تلفن ثابت'} name='phone' placeholder={'شماره تلفن ثابت خود را وارد کنید'} errors={errors} touched={touched} /> */}
    </>
  );
};

const MapStateToProps = (state) => ({
  mobileInfo: state.user.mobile,
  userGroup: state.user.customers_group_title,
});
export default connect(MapStateToProps)(FormFields);
